import styled from 'styled-components'
import "react-datepicker/dist/react-datepicker.css";

// Styled components
export const HomeContent = styled.div`
    width: 100%;    
    padding: 5rem 0 3% 3%;
    display: flex;
    box-sizing: border-box; 

    @media (max-width: 900px) {
        padding: 0;
        padding-top: 5rem;
        flex-direction: column;
        margin: 0;
    }
`

export const BoxContainer = styled.div`
    vertical-align: top;
    display: inline-block;
    margin-right: 3%;
    margin-bottom: 2rem;
    width: ${ props => props.column ? "100" : props.size }%;
    background: white;
    position: relative;
    padding: 3rem;
    border-radius: 3px;
    box-shadow: 1px 1px 10px rgba(50, 50, 50, 0.2);
    box-sizing: border-box; 
    height: fit-content;

    h3 {
        margin: 0;
        text-align: center;
    }

    @media (max-width: 900px) {
        width: ${ props => props.column ? "100" : "90" }%;
        margin: auto;
        margin-bottom: 2rem;
    }
`

export const InfoBoxesContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 32%;

    .hr-min {
        margin: 1rem auto;
    }
    
    @media (max-width: 900px) {
        width: 90%;
        margin: auto;
    }
`
